module.exports = __webpack_public_path__ + "static/media/bg.4c10ae14.png";